/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef, useState } from 'react'

const HorizontallyScrolleableElement = ({ children }) => {
  const ref = useRef(null)

  const [xAtMouseDown, setXAtMouseDown] = useState(0)
  // save mouse position at click, and add oposite scroll value on movement
  const [isDragging, setIsDragging] = useState(false)

  const handleMouseDown = (e) => {
    setIsDragging(true)
    setXAtMouseDown(e.clientX)
  }
  const handleMouseMove = (e) => {
    e.preventDefault()
    if (isDragging) {
      ref.current.scrollLeft += -((e.clientX - xAtMouseDown) / 5)
    }
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }
  const onWheel = (e) => {
    const scrolledDistance = e.deltaY
    ref.current?.scrollTo({
      left:
        ref.current.scrollLeft
        + scrolledDistance
        + (scrolledDistance > 0 ? 50 : -50),
      behavior: 'smooth',
    })
  }
  const onWheelThrottled = throttle(onWheel, 100)
  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      className={`overflow-x-scroll overscroll-contain ${
        ref?.current?.scrollWidth <= ref?.current?.clientWidth
          ? 'default'
          : isDragging
            ? 'cursor-grabbing'
            : 'cursor-grab'
      }`}
      ref={ref}
      onWheel={onWheelThrottled}
      style={{ overflow: isDragging ? 'hidden' : 'auto' }}
    >
      {children}
    </div>
  )
}

export default HorizontallyScrolleableElement

export function throttle(fn, delay) {
  let timer
  return (...args) => {
    if (timer) return
    timer = setTimeout(() => {
      fn(...args)
      timer = null
    }, delay)
  }
}
